import { List, Delete, ChangeStatus } from "../../services/offer.services";
import { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import { handleServerValidations } from "../../../../utils/commonfunction";
import { DatePicker, Tooltip, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";

const CalendarCaret = () => <i className="fi fi-rr-calendar calendar-icon-inside" />;

export default function ListBusinessCoupons() {
  const { t } = useTranslation();
  const { pgno } = useParams();
  const [page, setPage] = useState(Number(pgno) || 1);
  const [itemperpage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [limit] = useState(10);

  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ title: null, date: null });
  const navigate = useNavigate();
  const [statsupdate, setStatusUpdate] = useState("false");

  function useDebounce(value, delay = 500) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      const timer = setTimeout(() => setDebouncedValue(value), delay);
      return () => clearTimeout(timer);
    }, [value, delay]);
    return debouncedValue;
  }

  useEffect(() => {
    if (page !== Number(pgno)) {
      navigate(`/business/coupons/${page}`);
    }
  }, [page]);

  useEffect(() => {
    const newPage = Number(pgno) || 1;
    if (newPage !== page) {
      setPage(newPage);
    }
  }, [pgno]);

  const debouncedFilters = useDebounce(filters, 600);

  const fetchCoupons = async () => {
    try {
      setLoading(true);
      const response = await List({ ...debouncedFilters, page, limit });
      setCoupons(response.data?.list || []);
      setTotalPages(Math.ceil((response.data?.total_records || 1) / limit));
    } catch (error) {
      console.error("Error fetching promotions", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCoupons();
  }, [debouncedFilters, page, statsupdate]);

  const renderOfferDetails = (coupon) => {
    if (coupon.discountType === "BUY_X_GET_Y_FREE") {
      return `Buy ${coupon.buyXQty} Get ${coupon.freeYQty} Free`;
    }
    if (coupon.discountType === "Fixed_Amount") {
      return `₹${coupon.discountValue}`;
    }
    if (coupon.discountType === "PERCENTAGE_DISCOUNT") {
      return `${coupon.discountValue}%`;
    }
    return "—";
  };

  const viewfunction = (row) => {
    navigate(`/business/coupons/view/${row._id}`);
  };

  const Editfunction = (row) => {
    navigate(`/business/coupons/edit/${row._id}`);
  };

  const Deletefunction = (id) => {
    Swal.fire({
      customClass: "swal-wide",
      title: "Are you sure?",
      text: "Do you want to delete the business?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        let ids = [id];
        Delete({ o_id: JSON.stringify(ids) })
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              fetchCoupons();
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  const ChangeOfferStatus = (data, Num) => {
    let ids = Array.isArray(data) ? data : [data];
    const formData = new FormData();
    formData.append("o_id", JSON.stringify(ids));
    formData.append("status", Num);
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("Do you want to change the status?"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
      cancelButtonText: t("btn_cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        ChangeStatus(formData)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate((prev) => !prev);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };

  const resetFilter = () => {
  
    setFilters({ title: null, date: null });
   
  };
 

  return (
    <div className="main-content">
      <div className="customer-part">
        <div className="card-box">
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 w-100 mb-4">
            <div className="search-bar d-flex flex-wrap align-items-center gap-2">
              <div className="search-input">
              <input type="text" className="form-control" placeholder="Search by name" value={filters?.name||""} onChange={(e) => setFilters({ ...filters, name: e.target.value })} />
              <i className="fi fi-rs-search" />
              </div>

           

              <div className="date-input">
                <DatePicker
                  value={filters.date ? new Date(filters.date) : null}
                  onChange={(date) => {
                    setFilters({ ...filters, date: date });
                  }}
                  format="yyyy-MM-dd"
                  placeholder="Select date"
                  cleanable={true}
                  oneTap={true}
                  caretAs={CalendarCaret}
                  className="custom-date-picker"
                />
              </div>

              <button type="reset" value="Reset" onClick={()=>resetFilter()} className="btn btn-oring ripple">
                {t("btn_reset_filter")}
              </button>
            </div>

            <Link to={"/business/coupons/add"} className="btn btn-oring text-nowrap">
              Create Offer
            </Link>
          </div>

          {/* Coupons Table */}
          <div className="table-box table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Title</th>
                  {/* <th>Promotion Code</th> */}
                  {/* <th>Discount Type</th> */}
                  {/* <th>Details</th> */}
                  <th>Status</th>
                  <th>Expiry Date</th>
                  <th>Created At</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7">Loading...</td>
                  </tr>
                ) : coupons.length === 0 ? (
                  <tr className="text-center">
                    <td className="m-2" colSpan="7">
                      No Coupons Found
                    </td>
                  </tr>
                ) : (
                  coupons.map((coupon, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{coupon.name}</td>
                      {/* <td>{coupon.code}</td> */}
                      {/* <td>
                        {coupon.discountType
                          .replaceAll("_", " ")
                          .toLowerCase()
                          .split(" ")
                          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(" ")}
                      </td> */}
                      {/* <td>{renderOfferDetails(coupon)}</td> */}
                      <td>
                        <span className={`badge text-white ${coupon.status === true ? "bg-success" : "bg-secondary"}`}>{coupon.status === true ? "Active" : "Inactive"}</span>
                      </td>
                      <td>{new Date(coupon.expiry_date).toLocaleDateString()}</td>
                      <td>{new Date(coupon.createdAt).toLocaleDateString()}</td>

                      <td>
                        <label className={"custom-switch cp" + (coupon.status !== true ? " e_none" : "")}>
                          <input className="custom-switch-input cp" type="checkbox" checked={coupon?.status === true} onChange={() => ChangeOfferStatus(coupon?._id, coupon?.status === true ? 0 : 1)} />
                          <span className="custom-switch-indicator cp"></span>
                        </label>
                      </td>

                      <td>
                        <div className="btn-toolbar table-actions" role="toolbar">
                          <div className="btn-group btn-group-sm" role="group">
                            <Whisper placement="top" trigger="hover" speaker={<Tooltip>View</Tooltip>}>
                              <button type="button" className="btn view" onClick={() => viewfunction(coupon)}>
                                <i className="ri-eye-fill"></i>
                              </button>
                            </Whisper>
                            <Whisper placement="top" trigger="hover" speaker={<Tooltip>Edit</Tooltip>}>
                              <button type="button" className="btn edit" onClick={() => Editfunction(coupon)}>
                                <i className="ri-pencil-fill"></i>
                              </button>
                            </Whisper>
                            <Whisper placement="top" trigger="hover" speaker={<Tooltip>Delete</Tooltip>}>
                              <button type="button" className="btn delete" onClick={() => Deletefunction(coupon?._id)}>
                                <i className="ri-delete-bin-6-fill"></i>
                              </button>
                            </Whisper>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            <div className="pagination-controls d-flex justify-content-end align-items-center gap-2 mt-3">
              <button onClick={() => setPage((prev) => Math.max(prev - 1, 1))} disabled={page === 1}>
                Previous
              </button>

              <span>
                Page {page} of {totalPages}
              </span>

              <button onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))} disabled={page === totalPages}>
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
